import { Injectable } from '@angular/core';
import {PushInfo} from "../fcm/fcm.service";
import {LayoutMgrService} from "../layout-mgr/layout-mgr.service";

@Injectable({
  providedIn: 'root'
})
export class NotiService {

  constructor(
    private lm: LayoutMgrService,
  ) { }

  public addNotification(pushInfo: PushInfo): void {
    this.lm.OpenNotiPopup(pushInfo);
  }
}
